import UserDetailsBar from './UserDetailsBar';

export default UserDetailsBar;
